import React, { FunctionComponent } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Box,
  Stack,
  Typography,
  Grid,
} from "@mui/material";
import { Button } from "../Button";
import { ProductGrid } from "../ProductGrid";
import { useProductPanel } from "./hook";
import { CustomSnackbar } from "../CustomSnackbar";
import { CustomChip } from "../CustomChip";
import { CustomInput } from "../CustomInput";

export const ProductPanel: FunctionComponent<{ username?: string }> = (
  props,
) => {
  const {
    assignedProducts,
    search,
    onChange,
    assignProduct,
    onUpdateAssignedProducts,
    products,
    snackbarState,
    onCloseSnackbar,
  } = useProductPanel(props.username);

  return (
    <>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        <CustomInput
          height={35}
          value={search}
          name="search"
          placeholder="Search"
          onChange={onChange}
        />
      </Box>
      <Card sx={{ boxShadow: 2, mt: 2, borderRadius: 4 }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              width: "100%",
              height: 400,
              overflowY: "scroll",
            }}
          >
            {products
              .filter((item) => {
                if (!search) {
                  return item;
                } else if (
                  item.description.toLowerCase().includes(search.toLowerCase())
                ) {
                  return item;
                }
              })
              .map((val) => {
                return (
                  <CustomChip
                    checked={assignedProducts.includes(parseInt(val.id))}
                    label={val.description}
                    onClick={() => assignProduct(parseInt(val.id))}
                  />
                );
              })}
          </Box>
        </CardContent>
        <CardActions>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
              borderTop: 1,
              backgroundColor: "#FAFAFA",
              borderColor: "#00000026",
              p: 2,
            }}
          >
            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                width={120}
                height={40}
                label="Cancel"
                onClick={() => alert(assignedProducts)}
              />
              <Button
                width={120}
                height={40}
                label="Save"
                onClick={onUpdateAssignedProducts}
              />
            </Stack>
          </Box>
        </CardActions>
        <CustomSnackbar
          open={snackbarState.isOpen}
          variant="secondary"
          level={snackbarState.level as any}
          message={snackbarState.message}
          onClose={onCloseSnackbar}
        />
      </Card>
    </>
  );
};
